import React from 'react';
import ClientLineItem from '../../../Domain/ClientLineItem';
import CreditApplyWindowItem from '../../../Domain/CreditApplyWindowItem';
import CreditMemoRequestItem from '../../../Domain/CreditMemo/CreditMemoRequestItem';
import LineItemCreditRequestItem from '../../../Domain/CreditMemo/LineItemCreditRequestItem';
import ButtonRow from '../../../Elements/ButtonRow';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ErrorMessage from '../../../Elements/ErrorMessage';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import Loading from '../../../Elements/loading';
import LoadingIcon from '../../../Elements/LoadingIcon';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import AssignmentService from '../../../Services/AssignmentService';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';
import ClientLineItemService from '../../../Services/ClientLineItemService';
import CreditMemoRequestService from '../../../Services/CreditMemo/CreditMemoRequestService';
import LineItemCreditRequestService from '../../../Services/CreditMemo/LineItemCreditRequestService';
import LookupItemService from '../../../Services/LookupItemService';
import EditAssignmentWindowDescription from '../Assignments/EditAssignmentWindowDescription';
import ApplyClientLineWindowDescription from './ApplyClientLineWindowDescription';
import EditClientLineWindowDescription from './EditClientLineWindowDescription';
import LineItemCreditRequestSearchParams from './LineItemCreditRequestSearchParams';
import CreditApplyLateFeeItem from '../../../Domain/CreditApplyLateFeeItem';

export default class LineItemCreditRequestTab extends React.Component {
  static defaultProps = {};

  selectAllWasAlreadyClicked = false;
  creditMemoRequestId = new URLSearchParams(window.location.search).get('id');

  constructor(props) {
    super(props);
    const searchParams = new LineItemCreditRequestSearchParams();
    this.state = {
      itemList: [],
      loading: true,
      searchItem: searchParams,
      shownPanel: ShownPanelsEnum.None,
      creditMemoRequest: new CreditMemoRequestItem(),
      invoiceMaxTotal: 9999999999,
      numberOfElementsInTheTable: 0,
      currentCreditAmount: 0,
      applyCreditDataLoading: true,
      notSelectedCreditAmount: 0,
      selectedItemsFeeBase: 0,
      selectedItemsReimbursement: 0,
    };

    this.startSearch = this.startSearch.bind(this);
    this.changeOfItemListFunction = this.changeOfItemListFunction.bind(this);
    this.showPanel = this.showPanel.bind(this);
    this.getSelectedItems = this.getSelectedItems.bind(this);
    LineItemCreditRequestItem.editFunction = this.clickOnEditIcon.bind(this);
    LineItemCreditRequestItem.clickOnSelect = this.clickOnSelect.bind(this);
    LineItemCreditRequestItem.selectedStatus = this.selectedStatus.bind(this);
    LineItemCreditRequestItem.clickOnGlobalSelect = this.selectAllElements.bind(this);
  }

  selectAllElements() {
    const selectedStatus = this.state.itemList.some((item) => item.Selected === false);
    const templist = [...this.state.itemList];

    if (templist !== undefined && templist.length > 0) {
      templist.map((c) => (c.Selected = selectedStatus));
    }
    this.setState({ itemList: templist });
  }

  selectedStatus() {
    if (this.state.itemList.some((x) => x.Selected === false)) return false;

    return true;
  }

  clickOnSelect(item, selected) {
    item.Selected = selected;
    const tempList = [...this.state.itemList];
    if (tempList !== undefined) {
      const tempInstance = tempList.find((c) => c.LineItemId === item.LineItemId);
      if (tempInstance.length !== 0) {
        tempInstance.Selected = selected;

        this.setState({ itemList: tempList });
      }
    }

    this.setState({ applyCreditDataLoading: true });
  }

  getCreditMemoRequestData() {
    CreditMemoRequestService.GetById(this.creditMemoRequestId)
      .then((result) => {
        this.setState({
          searchItem: { ...this.state.searchItem, CreditMemoStatus: result.statusCode },
          creditMemoRequest: result,
          loading: false,
        });
        return result;
      })
      .then((result) => {
        ClientInvoiceService.GetById(result.clientInvoiceId).then((inv) =>
          this.setState({ invoiceMaxTotal: inv.ciTotal })
        );
      })
      .catch(() => ErrorMessage.SetErrorMessage('LICT40'));
  }

  componentDidMount() {
    this.getCreditMemoRequestData();
  }

  async clickOnEditIcon(selectedId, selectedItem) {
    if (selectedItem.Type === 'Assignment') {
      const assignmentData = await AssignmentService.GetAssignmentById(selectedItem.LineItemId);

      if (assignmentData.ciStatusCode === 1 || assignmentData.ieStatusCode === 1) {
        const invStatus = await LookupItemService.GetLookupItemByLookupIdAndLookupValue(
          43,
          assignmentData.ciStatusCode
        );
        assignmentData.invoiceStatus = invStatus.text;

        const evPaymentStatus = await LookupItemService.GetLookupItemByLookupIdAndLookupValue(
          45,
          assignmentData.ieStatusCode
        );
        assignmentData.evaluatorPaymentStatus = evPaymentStatus.text;
      }
      this.windowDescription = EditAssignmentWindowDescription;

      this.setState({
        selectedItem,
        selectedItemExtended: assignmentData,
        shownPanel: ShownPanelsEnum.EditItem,
        extendedLoading: false,
      });
      return;
    }
    const clientLineItemData = await ClientLineItemService.GetById(selectedItem.LineItemId);
    const clientLineItem = new ClientLineItem(clientLineItemData);
    this.windowDescription = EditClientLineWindowDescription;

    this.setState({
      selectedItem,
      selectedItemExtended: clientLineItem,
      shownPanel: ShownPanelsEnum.EditItem,
      extendedLoading: false,
    });
  }

  startSearch(searchItem) {
    this.setState({
      searchItem,
    });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  getSelectedItems(itemType) {
    const selectedItemsByType = this.getSelectedElementsList().filter((f) => f.Type === itemType);
    if (selectedItemsByType.length > 0) {
      if (itemType === 'LineItem') {
        return selectedItemsByType.map((m) => m.LineItemId);
      }
      if (itemType === 'Assignment') {
        return selectedItemsByType.map((m) => m.LineItemId);
      }
    }
    return null;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItemExtended}
            clickOnCancel={this.editPanelOnClose.bind(this)}
            clickOnSave={this.savePanelOnClose.bind(this)}
            windowDescription={this.windowDescription}
            errorCode={'LICRT179'}
          />
        )}
        {this.state.applyCreditDataLoading
          ? this.renderOnePanel(ShownPanelsEnum.ApplyCredit, <LoadingIcon />)
          : this.renderOnePanel(
              ShownPanelsEnum.ApplyCredit,
              <GeneralEditWizzardBase
                editedItem={
                  new CreditApplyWindowItem(
                    this.getSelectedItems('LineItem'),
                    this.getSelectedItems('Assignment'),
                    this.state.creditMemoRequest,
                    this.state.selectedItemsFeeBase,
                    this.state.selectedItemsReimbursement,
                    this.state.notSelectedCreditAmount,
                    this.state.invoiceMaxTotal,
                    this.state.allItemsInTheSearchSetAreSelected,
                    this.state.searchItem
                  )
                }
                clickOnCancel={this.editPanelOnClose.bind(this)}
                clickOnSave={this.savePanelOnClose.bind(this)}
                windowDescription={ApplyClientLineWindowDescription}
                errorCode={'LICRT203'}
              />
            )}
      </div>
    );
  }

  savePanelOnClose() {
    this.getCreditMemoRequestData();
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      searchItem: { ...this.state.searchItem },
      applyCreditDataLoading: true,
    });
  }

  editPanelOnClose() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      applyCreditDataLoading: true,
    });
  }

  areAllItemsSelected() {
    return this.state.itemList.find((i) => i.Selected === false) === undefined;
  }

  renderButtonsAndPanels() {
    const isButtonDisabled = this.getNumberOfSelectedElements() === 0 || this.state.searchItem.CreditMemoStatus !== 1;
    return (
      <>
        {this.state.creditMemoRequest.reason === 'Tax Credit' ? (
          // Show Apply tax credit buttons here
          <ButtonRow
            tooltips={['Apply Tax Credit', 'Apply Reimbursement Tax Credit', 'Unapply Tax Credit']}
            labels={['Tax Credit', 'Reimb. Credit', 'Tax Credit']}
            colors={[ButtonColorsEnum.Primary, ButtonColorsEnum.Primary, ButtonColorsEnum.Destruct]}
            keys={[
              ShownPanelsEnum.ApplyTaxCredit,
              ShownPanelsEnum.ApplyReimbursementTaxCredit,
              ShownPanelsEnum.UnapplyTaxCredit,
            ]}
            icons={['fa-solid fa-plus-circle', 'fa-solid fa-plus', 'fa-solid fa-minus-circle']}
            roleKeys={[
              'creditmemo_editbuttonrowbutton',
              'creditmemo_editbuttonrowbutton',
              'creditmemo_editbuttonrowbutton',
            ]}
            value={this.state.shownPanel}
            onClick={this.showPanel}
            disabled={[isButtonDisabled, isButtonDisabled, isButtonDisabled]}
          />
        ) : this.state.creditMemoRequest.reason === 'Late Fee Credit' ? (
          // Show late fee buttons here
          <ButtonRow
            tooltips={['Apply Late Fee Credit', 'Unapply Late Fee Credit']}
            labels={['Late Fee Credit', 'Late Fee Credit']}
            colors={[ButtonColorsEnum.Primary, ButtonColorsEnum.Destruct]}
            keys={[ShownPanelsEnum.ApplyLateFeeCredit, ShownPanelsEnum.UnapplyLateFeeCredit]}
            icons={['fa-solid fa-plus-circle', 'fa-solid fa-minus-circle']}
            roleKeys={['creditmemo_editbuttonrowbutton', 'creditmemo_editbuttonrowbutton']}
            value={this.state.shownPanel}
            onClick={this.showPanel}
            disabled={[isButtonDisabled, isButtonDisabled]}
          />
        ) : (
          <ButtonRow
            tooltips={['Apply Credit']}
            colors={[ButtonColorsEnum.Primary]}
            keys={[ShownPanelsEnum.ApplyCredit]}
            icons={['fa-solid fa-plus-circle']}
            roleKeys={['creditmemo_editbuttonrowbutton']}
            value={this.state.shownPanel}
            onClick={this.showPanel}
            disabled={[isButtonDisabled]}
          />
        )}
        {this.renderPanels()}
        {this.areAllItemsSelected() ? this.showAllItemSelectorLink() : null}
      </>
    );
  }

  showAllItemSelectorLink() {
    return (
      <div className='text-center'>
        {this.state.allItemsInTheSearchSetAreSelected ? (
          <div
            className='link'
            onClick={() => this.setState({ allItemsInTheSearchSetAreSelected: false })}
          >
            Currently all line items ({this.state.numberOfElementsInTheTable}) in the actual search set are selected.
          </div>
        ) : (
          <div
            className='link'
            onClick={() => this.setState({ allItemsInTheSearchSetAreSelected: true })}
          >
            Select all line items ({this.state.numberOfElementsInTheTable}) in the actual search set.
          </div>
        )}
      </div>
    );
  }

  showPanel(panelId) {
    if (this.getSelectedElementsList().length > 100) {
      ErrorMessage.SetErrorMessage(
        'You cannot have more than 100 items selected on the same page. Use the "select all line items" button with narrowed down search parameters.'
      );
      return;
    }

    LineItemCreditRequestService.GetDataForCreditApply(
      this.state.searchItem,
      this.state.allItemsInTheSearchSetAreSelected,
      this.state.allItemsInTheSearchSetAreSelected ? [] : this.getSelectedElementsListForApplyCredit()
    )
      .then((result) => {
        if (result.error) {
          this.handleCreditApplyPrerequisiteError(result);
        } else {
          this.setCreditApplyPrerequisiteData(result);
        }
      })
      .catch(() => ErrorMessage.SetErrorMessage('LICT284'));

    if (
      [
        ShownPanelsEnum.ApplyTaxCredit,
        ShownPanelsEnum.ApplyReimbursementTaxCredit,
        ShownPanelsEnum.UnapplyTaxCredit,
      ].includes(panelId)
    ) {
      this.generateErrorMessage(panelId);
      return;
    } else if (panelId === ShownPanelsEnum.ApplyLateFeeCredit || panelId === ShownPanelsEnum.UnapplyLateFeeCredit) {
      const editedItem = this.getLateFeeEditedItem(panelId);

      const popupMessage =
        panelId === ShownPanelsEnum.ApplyLateFeeCredit ? 'Apply Late Fee Credit' : 'Unapply Late Fee Credit';

      ErrorMessage.SetApprove(`${popupMessage} for selected line items. Are you sure?`, () =>
        this.handleLateFeeApplyApprove(editedItem)
      );
    }

    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  setCreditApplyPrerequisiteData(result) {
    this.setState({
      notSelectedCreditAmount: result.notSelectedCreditAmount,
      selectedItemsFeeBase: result.selectedItemsFeeBase,
      selectedItemsReimbursement: result.selectedItemsReimbursement,
      applyCreditDataLoading: false,
    });
  }

  handleCreditApplyPrerequisiteError(result) {
    ErrorMessage.SetErrorMessage(result.error);
    this.setState({ loading: false });
  }

  generateErrorMessage(panelId) {
    const popupMessage =
      panelId === ShownPanelsEnum.ApplyTaxCredit
        ? 'Apply Tax Credit'
        : panelId === ShownPanelsEnum.ApplyReimbursementTaxCredit
        ? 'Apply Reimbursement Tax Credit'
        : 'Unapply Tax Credit';

    const editedItem = this.getTaxCreditEditedItem(panelId);

    ErrorMessage.SetApprove(`${popupMessage} for selected line items. Are you sure?`, () =>
      this.handleCreditTaxApplyApprove(editedItem)
    );
  }

  getTaxCreditEditedItem(panelId) {
    const actionCode =
      panelId === ShownPanelsEnum.ApplyTaxCredit ? 1 : panelId === ShownPanelsEnum.ApplyReimbursementTaxCredit ? 2 : 3;

    return new CreditApplyWindowItem(
      this.getSelectedItems('LineItem'),
      this.getSelectedItems('Assignment'),
      this.state.creditMemoRequest,
      this.state.selectedItemsFeeBase,
      this.state.selectedItemsReimbursement,
      this.state.notSelectedCreditAmount,
      this.state.invoiceMaxTotal,
      this.state.allItemsInTheSearchSetAreSelected,
      this.state.searchItem,
      actionCode
    );
  }

  getLateFeeEditedItem(panelId) {
    const creditPercentFee = panelId === ShownPanelsEnum.ApplyLateFeeCredit ? 100 : 0;
    const creditPercentReimbursement = 0;

    return new CreditApplyLateFeeItem(
      this.getSelectedItems('LineItem'),
      this.getSelectedItems('Assignment'),
      this.state.creditMemoRequest,
      this.state.allItemsInTheSearchSetAreSelected,
      this.state.searchItem,
      creditPercentFee,
      creditPercentReimbursement
    );
  }

  handleLateFeeApplyApprove(editedItem) {
    LineItemCreditRequestService.ApplyCredit(editedItem)
      .then((result) => {
        if (result.success && result.success.length > 0) {
          const successMessage = this.getResultMessageFromArray(result.success);
          ErrorMessage.SetNotification(successMessage);
        }
        if (result.failure && result.failure.length > 0) {
          const failureMessage = this.getResultMessageFromArray(result.failure);
          ErrorMessage.SetErrorMessage(failureMessage);
        }

        this.refresh();
      })
      .catch(() => ErrorMessage.SetErrorMessage('LICT429'));
  }

  getResultMessageFromArray(result) {
    return (
      <div>
        {result.map((s) => (
          <div>{s}</div>
        ))}
      </div>
    );
  }

  handleCreditTaxApplyApprove(editedItem) {
    LineItemCreditRequestService.ApplyTaxCredit(editedItem)
      .then((result) => {
        if (result.success && result.success.length > 0) {
          const successMessage = this.getResultMessageFromArray(result.success);
          ErrorMessage.SetNotification(successMessage);
        }
        if (result.failure && result.failure.length > 0) {
          const failureMessage = this.getResultMessageFromArray(result.failure);
          ErrorMessage.SetErrorMessage(failureMessage);
        }

        this.refresh();
      })
      .catch(() => ErrorMessage.SetErrorMessage('LICT370'));
  }

  refresh() {
    this.startSearch({ ...this.state.searchItem });
  }

  getSelectedElementsList() {
    return this.state.itemList.filter((x) => x.Selected === true);
  }

  getSelectedElementsListForApplyCredit() {
    return this.state.itemList.filter((x) => x.Selected === true).map((item) => item.LineItemId);
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  changeOfItemListFunction(itemList, numberOfElementsInTheTable) {
    this.setState({
      itemList,
      numberOfElementsInTheTable,
      allItemsInTheSearchSetAreSelected: false,
    });
  }

  render() {
    return this.state.loading || this.state.extendedLoading ? (
      <Loading />
    ) : (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={LineItemCreditRequestItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={LineItemCreditRequestService.GetListBySearching}
          convertDBItemsFunction={LineItemCreditRequestService.ConvertDBItemList}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          orderBy={this.state.orderBy}
          showSearchStrip={true}
          searchParamsType={LineItemCreditRequestSearchParams}
          clickOnStartSearch={this.startSearch}
          enableUrlPush={false}
          isFilterDisabled={this.state.searchItem.CreditMemoStatus === 2}
          itemList={this.state.itemList}
          changeOfItemListFunction={this.changeOfItemListFunction}
          errorCode='LICRT501'
        />
      </div>
    );
  }
}
